import React from 'react';
export function HowItWorks() {
  return <section className="w-full py-20 px-4" style={{
    backgroundColor: '#F5F6FA'
  }} id="how-it-works" aria-label="How it works" data-id="element-58">
      <div className="max-w-5xl mx-auto" data-id="element-59">
        {/* Headings */}
        <div className="text-center mb-16" data-id="element-60">
          <h2 className="font-bold text-4xl" style={{
          color: '#1B2A4A'
        }} data-id="element-61">
            Simple, Secure Process
          </h2>
          <p className="text-gray-500 text-base mt-3" data-id="element-62">
            From file submission to final delivery — we make it easy
          </p>
        </div>

        {/* Steps */}
        <div className="relative flex flex-col md:flex-row gap-10 md:gap-0 items-start" data-id="element-63">
          {/* Dashed connector line (desktop only) */}
          <div className="hidden md:block absolute top-8 left-[calc(16.666%+2rem)] right-[calc(16.666%+2rem)] border-t-2 border-dashed border-gray-300" aria-hidden="true" data-id="element-64" />

          {/* Step 1 */}
          <div className="flex flex-col items-center text-center flex-1 px-4 relative z-10" data-id="element-65">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-2xl mb-6 shadow-md" style={{
            backgroundColor: '#2DA5A0'
          }} aria-label="Step 1" data-id="element-66">
              1
            </div>
            <h3 className="font-bold text-lg mb-3" style={{
            color: '#1B2A4A'
          }} data-id="element-67">
              Submit Your Files
            </h3>
            <p className="text-sm leading-relaxed max-w-xs mx-auto" style={{
            color: '#1E1E1E'
          }} data-id="element-68">
              Use our secure, HIPAA-compliant portal. No complicated forms —
              just bookmark and upload.
            </p>
          </div>

          {/* Step 2 */}
          <div className="flex flex-col items-center text-center flex-1 px-4 relative z-10" data-id="element-69">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-2xl mb-6 shadow-md" style={{
            backgroundColor: '#2DA5A0'
          }} aria-label="Step 2" data-id="element-70">
              2
            </div>
            <h3 className="font-bold text-lg mb-3" style={{
            color: '#1B2A4A'
          }} data-id="element-71">
              We Get to Work
            </h3>
            <p className="text-sm leading-relaxed max-w-xs mx-auto" style={{
            color: '#1E1E1E'
          }} data-id="element-72">
              Our experienced team transcribes or translates your content with
              meticulous attention to detail.
            </p>
          </div>

          {/* Step 3 */}
          <div className="flex flex-col items-center text-center flex-1 px-4 relative z-10" data-id="element-73">
            <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-2xl mb-6 shadow-md" style={{
            backgroundColor: '#2DA5A0'
          }} aria-label="Step 3" data-id="element-74">
              3
            </div>
            <h3 className="font-bold text-lg mb-3" style={{
            color: '#1B2A4A'
          }} data-id="element-75">
              Receive &amp; Review
            </h3>
            <p className="text-sm leading-relaxed max-w-xs mx-auto" style={{
            color: '#1E1E1E'
          }} data-id="element-76">
              Get your polished, proofread deliverables on time. View invoices
              and process payments in our secure portal.
            </p>
          </div>
        </div>
      </div>
    </section>;
}